export default function CurrentElement() {
  const topListItems = Array.from(
    document.querySelectorAll('.list-element-links > li')
  )
  const bottomListItems = Array.from(
    document.querySelectorAll('.content-list > li')
  )

  if (!topListItems || !bottomListItems) return

  if (
    topListItems.length === 0 ||
    bottomListItems.length === 0 ||
    topListItems.length !== bottomListItems.length
  ) {
    return
  }

  const HEADER_HEIGHT_OFFSET = 80

  const TOP_PIXEL_THRESHOLD = 150

  let currentActiveIndex = -1

  const centerActiveItem = (targetItem) => {
    targetItem.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest'
    })
  }

  const setActiveElement = (index) => {
    if (index === currentActiveIndex) {
      return
    }

    topListItems.forEach((item) => item.classList.remove('active'))

    const activeItem = topListItems[index]
    activeItem.classList.add('active')

    centerActiveItem(activeItem)

    currentActiveIndex = index
  }

  const checkActiveElementOnScroll = () => {
    let activeIndexFound = false

    for (let i = bottomListItems.length - 1; i >= 0; i--) {
      const item = bottomListItems[i]
      const rect = item.getBoundingClientRect()

      if (rect.top <= TOP_PIXEL_THRESHOLD) {
        setActiveElement(i)
        activeIndexFound = true
        break
      }
    }

    if (!activeIndexFound && currentActiveIndex !== 0) {
      setActiveElement(0)
    }
  }

  window.addEventListener('scroll', checkActiveElementOnScroll, {
    passive: true
  })

  topListItems.forEach((item, index) => {
    item.addEventListener('click', (event) => {
      event.preventDefault()

      const targetElement = bottomListItems[index]
      const elementRect = targetElement.getBoundingClientRect()

      const targetPosition = window.scrollY + elementRect.top

      window.scrollTo({
        top: targetPosition - HEADER_HEIGHT_OFFSET,
        behavior: 'smooth'
      })
    })
  })

  checkActiveElementOnScroll()
}
